export default __webpack_public_path__ + "static/media/76.e7bec0d3.png";